<template>
    <div>

        <v-menu
            v-model="statusMenuModel"
            absolute
            offset-y
            style="max-width: 200px"
        >
            <template v-slot:activator="{ on }">
                <div v-on="on">
                    <v-chip v-if="project.status==='online'" color="green" text-color="white">
                        Online
                    </v-chip>
                    <v-chip v-if="project.status==='offline'" color="red" text-color="white">
                        Offline
                    </v-chip>
                    <v-chip v-if="project.status==='closed'" color="blue-grey" text-color="white">
                        Closed
                    </v-chip>
                    <v-chip v-if="project.status==='archived'" color="grey-darken-1" text-color="white">
                        Archived
                    </v-chip>

                </div>
            </template>

            <v-list class="pt-0 pb-0">
                <v-list-item
                    v-for="(item, index) in statuses"
                    :key="index"
                    @click="change(item.value, project.status)"
                    dense
                >
                    <v-list-item-title>
                        {{ item.name }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>

        </v-menu>

        <confirmation-dialog v-model="showArchiveConfirmationModel"
                             headline="Confirm archival?"
                             description="Archived projects do not accept any completes or terminates. It is recommended to close this
                            project first so that panelists can finish sessions that are currently in progress. Closed projects are automatically archived after a one month."
                             confirm-button-text="Archive"
                             abort-button-text="Abort"
                             @selected="changeConfirmed"
        ></confirmation-dialog>
    </div>

</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapActions} from 'vuex';
import ConfirmationDialog from "../../../components/UI/ConfirmationDialog";

const vuexModule = 'ProjectManager';

export default {

    components: {
        ConfirmationDialog,
        Json
    },

    props: {
        project: {
            type: Object,
            required: true
        },
    },

    computed: {
        statuses() {
            if (this.project.status === "archived") {
                return [
                    {name: 'Un-archive', value: 'offline'}
                ];
            } else {
                return [
                    {name: 'Online', value: 'online'},
                    {name: 'Closed', value: 'closed'},
                    {name: 'Archived', value: 'archived'},
                    {name: 'Offline', value: 'offline'}
                ];
            }
        },
    },

    data() {
        return {
            statusMenuModel: false,
            showArchiveConfirmationModel: false,
        }
    },

    methods: {
        ...mapActions(vuexModule, [
            'changeProjectStatus'
        ]),

        change(newStatus, oldStatus) {

            if (['online', 'offline'].includes(oldStatus) && newStatus === 'archived') {
                this.showArchiveConfirmationModel = true;
            } else {
                this.sendRequest(newStatus);
            }
        },

        changeConfirmed(result) {
            this.showArchiveConfirmationModel = false;

            if (result) {
                this.sendRequest('archived');
            }
        },

        sendRequest(status) {
            this.changeProjectStatus({id: this.project.id, status: status})
                .catch((error) => {
                    Bus.$emit('flash-message', {type: 'error', message: 'Hmm. Failed changing project status!'})
                    throw new Error(error);
                });
        }
    }

}
</script>
